import clsx from "clsx"
import { useCallback, useRef } from "react"
import QuickPinchZoom, { make3dTransformValue } from "react-quick-pinch-zoom"

import styles from "./ImageViewer.module.scss"
import { ImageViewerProps } from "./ImageViewer.types"

export default function ImageViewer(props: ImageViewerProps) {
    const { src, alt, className } = props

    const imgRef = useRef<HTMLImageElement>(null)

    const onUpdate = useCallback(({ x, y, scale }: { x: number; y: number; scale: number }) => {
        const img = imgRef.current
        if (img) {
            const value = make3dTransformValue({ x, y, scale })
            img.style.setProperty("transform", value)
        }
    }, [])

    return (
        <div className={clsx(styles.container, className)}>
            <QuickPinchZoom onUpdate={onUpdate} tapZoomFactor={2} zoomOutFactor={1.3}>
                <img ref={imgRef} src={src} alt={alt} className={styles.image} draggable={false} />
            </QuickPinchZoom>
        </div>
    )
}
